function LoadingComp({ heightcomp }) {
  return (
    <div className={`loading-centercomp ${heightcomp}`}>
      <div className="loader2 ">
        <span className="loader__element"></span>
        <span className="loader__element"></span>
        <span className="loader__element"></span>
      </div>
    </div>
  );
}

export default LoadingComp;
